"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hashScroller;
const isAvailable = id => id && typeof id === 'string' &&
// check whether there's any matching elements, then if so, use that string
window[id] && id;
const getUrlParameter = name => {
  const pulledName = name.replace(/[[]/, '[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[\\?&]${pulledName}=([^&#]*)`);
  const results = regex.exec(location.search); // eslint-disable-line no-restricted-globals
  return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
};
function hashScroller() {
  // prioritise any available '#' on the url, to match the browser's default behaviour
  // else use any available hash parameter
  const id = isAvailable(window.location.hash.substr(1)) || isAvailable(getUrlParameter('hash'));
  if (id) {
    window.location.assign(`#${id}`);
  }
}